(function () {
  if (window.novShareButtons) return;
  window.novShareButtons = true;

  // The native sheet is the only route to Instagram and TikTok, and it only
  // exists on touch devices, so the button ships hidden and is revealed here.
  if (navigator.share) {
    document.querySelectorAll('[data-share-native]').forEach(function (button) {
      button.hidden = false;
    });
  }

  function flashCopied(button) {
    var label = button.querySelector('.share-title');
    if (!label) return;

    var copied = label.getAttribute('data-copied-label');
    var original = label.getAttribute('data-copy-label') || label.textContent;
    if (!copied) return;

    label.textContent = copied;
    button.classList.add('is-copied');
    window.setTimeout(function () {
      label.textContent = original;
      button.classList.remove('is-copied');
    }, 2000);
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.left = '-9999px';
      document.body.appendChild(field);
      field.select();

      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(field);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var copyButton = event.target.closest('[data-share-copy]');
    if (copyButton) {
      event.preventDefault();
      copyToClipboard(copyButton.getAttribute('data-share-copy')).then(
        function () {
          flashCopied(copyButton);
        },
        function () {}
      );
      return;
    }

    // Instagram takes no link from the web, so route through the share sheet
    // where it is a target, and fall back to copy-and-open on desktop.
    var instagramButton = event.target.closest('[data-share-instagram]');
    if (instagramButton) {
      event.preventDefault();
      var igUrl = instagramButton.getAttribute('data-share-url');

      if (navigator.share) {
        navigator
          .share({
            title: instagramButton.getAttribute('data-share-title'),
            text: instagramButton.getAttribute('data-share-title'),
            url: igUrl
          })
          .catch(function () {});
      } else {
        copyToClipboard(igUrl).then(
          function () {
            flashCopied(instagramButton);
          },
          function () {}
        );
        window.open('https://www.instagram.com/', '_blank', 'noopener');
      }
      return;
    }

    var nativeButton = event.target.closest('[data-share-native]');
    if (nativeButton && navigator.share) {
      event.preventDefault();
      navigator
        .share({
          title: nativeButton.getAttribute('data-share-title'),
          text: nativeButton.getAttribute('data-share-title'),
          url: nativeButton.getAttribute('data-share-url')
        })
        .catch(function () {});
    }
  });
})();
